export const kpiConfig = {
  schedule: {
    yellow_threshold_pp: 10,
    red_threshold_pp: 20,
  },

  finance: {
    yellow_threshold_pct: 5, // 5% over budget = yellow
    red_threshold_pct: 10, // 10% over budget = red
    score_zero_at_over_pct: 40,
    trend_epsilon_pct: 0.25,
  },

  // Mission KPI: weighted subKPIs (outputs)
  // NOTE: A subKPI only contributes to Mission score if it has a valid target in missionTargets.ts
  mission: {
    subkpis: {
      trees_planted: {
        weight: 50,
        cadence: "weekly",
        permissible_days_late: 2,
        // cumulative metrics carry-forward last known value if missing at a reporting date
        aggregation: "cumulative",
        direction: "increase_is_good",
        tags: ["environmental", "restoration"],
      },
      volunteers: {
        weight: 30,
        cadence: "monthly",
        permissible_days_late: 5,
        // periodic metrics treat missing as zero for that reporting date (until entered)
        aggregation: "periodic",
        missing_policy: "zero",
        direction: "increase_is_good",
        tags: ["community", "engagement"],
      },
      students_day1: {
        label: "Students (Day 1)",
        weight: 20,
        cadence: "once", // milestone-ish cadence (keeps reliability expectations tight)
        permissible_days_late: 2,
        direction: "increase_is_good",
        aggregation: "periodic",
        // For hard minimum gates, it's better to treat missing as missing (not auto-zero)
        missing_policy: "missing",
        tags: ["education", "community"],
        evaluation: {
          kind: "milestone",
          // IMPORTANT: due_date should be project-specific. In local dev we can point to a per-project target field.
          // If your engine supports due_date_field_key/custom metadata, use that instead of hard-coding a date here.
          // due_date_field_key: "students_day1_due_date",
          freeze_after_due: true,
          policy: "soft_goal", // or "hard_minimum"
          goal: 10, // optional override; otherwise comes from missionTargets.ts
        },
      },
    },
  },

  data_reliability: {
    // If a subKPI doesn't specify permissible_days_late, use this default.
    default_permissible_days_late: 2,
    // After the grace period, reliability linearly decays to 0 over this many late days.
    decay_days: 14,
  },

  summary: {
    weights: {
      schedule: 25,
      finance: 25,
      mission: 30,
      data_reliability: 20,
    },
    include_reliability: true,
  },
};
